module.exports = __webpack_public_path__ + "img/table1.20145355.png";